/* eslint-disable */
// NOTE :: DO NOT EDIT :: this file is automatically generated by generate-environment-variables.js node script

export const envVariables: { [key: string]: string } = {
  CIRCLE_TAG: 'prod-purposeful-v131',
  PROJECT: 'purposeful',
  PRODUCT: 'purposeful',
};
export const latestTag: string = 'prod-purposeful-v131';
export const latestVersion: string = 'v131';
export const versions: { app: { [key: string]: string }, branch: string, npm_version: string, revision: string } = {
  app: {
    purposeful: '9.1.1',
    insightful: '3.2.0',
  },
  branch: 'HEAD',
  npm_version: '167.0.0',
  revision: 'f2ab03bc0',
};
/* eslint-enable */
